<template>
<v-container>
  <v-layout row>
    <v-flex xs12 sm6 offset-sm3>
  <p>下の「エントリーを確定する」ボタンを押してエントリーいただくことで、お客様は当サイトのプライバシー規約及び利用規約に同意の上、大会にエントリーされたことになります。</p>

  <v-btn v-if="item.remaining > 0" block error  @click="entry">エントリーを確定する</v-btn>
  <div v-else-if="item.remaining == 0" class="red--text">満員です</div>
  <v-flex xs12 sm4 class="my-3">
    <div >
      <h4 class="headline">エントリー内容</h4>
    </div>
  </v-flex>

<p>
<v-icon>event</v-icon>
{{item.startTime | dateformat}}</p>
<p>
<v-icon>location_on</v-icon>
{{item.location}}
</p>
<p>
チーム
<v-select
  v-bind:items="items"
  v-model="team"
  label="Select"
  single-line
  item-text="label"
  item-value="value"
  return-object
></v-select>
</p>
<p>
<v-icon>payment</v-icon>
参加費 ¥ {{item.entryFee}}/チーム
</p>
<v-divider></v-divider>
ご請求額：<span class="price" v-if="item.entryFee">¥ {{this.item.entryFee.toLocaleString()}}</span>

    <div >
      <h4 class="headline mt-4">支払い方法</h4>
    </div>

    <v-card flat>
      <v-card-text>
        <v-radio-group v-model="payMethod" :mandatory="false">
          <!--
          <v-radio label="銀行振込" value="BANK_TRANSFER"></v-radio>
          -->
          <v-radio label="現地払い" value="ON-SITE"></v-radio>
        </v-radio-group>
      </v-card-text>
    </v-card>

<v-btn v-if="item.remaining > 0" block error  @click="entry">エントリーを確定する</v-btn>
<div v-else-if="item.remaining == 0" class="red--text">満員です</div>

    </v-flex>
  </v-layout>
</v-container>
</template>



<script>
import firebase from 'firebase'

export default {
  components: {
    firebase
  },
  data () {
    return {
      payMethod: 'ON-SITE',
      item: {location: null},
      items: [],
      to: null,
      team: null,
      entrySize: null
    }
  },
  created () {
    firebase.auth().onAuthStateChanged((user) => {
      if (!user) {
        // サインインしていない状態
        // サインイン画面に遷移する等
        // 例:
        location.href = '/#/auth?mode=select&signInSuccessUrl=/tournamentconfirm/' + this.$route.params.id
      } else {
        // サインイン済み
      }
    })

    // select tournament
    var db = firebase.firestore()
    var docRef = db.collection('tournaments').doc(this.$route.params.id)

    // Read the document.
    docRef.get().then(doc => {
      if (doc.exists) {
        // Document read successfully.
        this.item = doc.data()
        this.to = '/tournamentconfirm/' + this.$route.params.id
        this.init()
      } else {
        console.log('No such document!')
      }
    }).catch(function (error) {
      console.log('Error getting document:', error)
    })
  },
  methods: {
    init: function () {
      var db = firebase.firestore()
      let query = db.collection('m2m_teams_users').where('user', '==', firebase.auth().currentUser.uid) // TODO
                                                  .where('role', '==', 'ADMIN')
      query.get().then(querySnapshot => {
        // this.entrySize = querySnapshot.size
        querySnapshot.forEach(documentSnapshot => {
          var obj = documentSnapshot.data()
          // user
          var docRef = db.collection('teams').doc(obj.team)
          docRef.get().then(doc => {
            if (doc.exists) {
              this.items.push({label: doc.data().teamName, value: doc.id})
              this.team = {label: doc.data().teamName, value: doc.id}
              // this.team.value = doc.id
            } else {
              console.log('No such document!')
            }
          }).catch(function (error) {
            console.log('Error getting document:', error)
          })
        })
      })
    },
    entry: function () {
      // if (!this.items.size) {
      //   this.$router.push('/user/profile?u=/tournamentconfirm/' + this.$route.params.id)
      //   return
      // }
      var db = firebase.firestore()
      var id = this.$route.params.id + this.team.value // TODO

      const document = db.collection('entries').doc(id) // + this.$route.params.id)
      document.set({
        team: this.team.value,
        tournament: this.$route.params.id,
        payMethod: this.payMethod,
        time: new Date().getTime()
      }).then(() => {
        // Document created successfully.

        // update tournament
        // let remainings = this.item.capacity - this.entrySize
        var docRef = db.collection('tournaments').doc(this.$route.params.id)
        // let updremaining = docRef.data().remaining - 1
        // console.log('remaining->', updremaining)
        docRef.get().then(doc => {
          docRef.update({remaining: doc.data().remaining - 1})
        }).catch(function (error) {
          console.log('Error getting document:', error)
        })

//        docRef.update({remaining: docRef.data().remaining - 1})
        this.$router.push('/tournamententered/' + id)
      })
    }
  }
}
</script>

<style>
.price {
  color: #800000;
  font-size: 20px;
}


.ggmap {
position: relative;
padding-bottom: 56.25%;
padding-top: 30px;
height: 0;
overflow: hidden;
}
 
.ggmap iframe,
.ggmap object,
.ggmap embed {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/tournament/TournamentConfirm.vue